import {Component, Inject, AfterViewInit, ViewChild, ElementRef, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatInput} from "@angular/material/input";

@Component({
  selector: 'app-print-receipt-modal',
  templateUrl: './print-receipt-modal.component.html',
  styleUrls: ['./print-receipt-modal.component.scss']
})
export class PrintReceiptModalComponent implements AfterViewInit {
  change: number = 0;

  constructor(
    public dialogRef: MatDialogRef<PrintReceiptModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngAfterViewInit() {
  }

  calculateChange($event: any): void {
    const value = $event.target.value;
    this.change = value - this.data.totalAmount;
  }

}
